/**
 * @generated SignedSource<<b1261516b1701d646d6df2af2774213d>>
 * @relayHash 42a1fc3d049d5131ab23b40e1ecff43b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c167b4cad1630f805052348b8f47c378a21963465929ed7cade1417f655584c3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c167b4cad1630f805052348b8f47c378a21963465929ed7cade1417f655584c3",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
